import { useTheme } from '@components/theme';
import React from 'react';
import classNames from 'classnames';
import styles from './CTA.module.scss';

interface ICTA {
  children:React.ReactNode;
  type: 'Solid' | 'Outline';
  className?: string;
  handler(): void;
  testSelector?: string;
}

const CTA = ({
  children, className, handler, testSelector, type
}: ICTA) => {
  const theme = useTheme();
  return (
    <button
      data-test={testSelector}
      type="button"
      onClick={handler}
      className={classNames(
        theme.styles.Button,
        {
          [theme.styles.Primary]: type === 'Solid',
          [theme.styles.Secondary]: type === 'Outline'
        },
        styles.CTA,
        className
      )}
    >
      { children }
    </button>
  );
};

export default CTA;
